import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetSoldOrderList } from "../../../utilities/api/pos";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

const initialState = {
  currentPage: 0,
  rowsPerPage: 0,
  totalPage: 0,
  totalRows: 0,
  SoldProductData: [] as any[],
  errorMessage: {} as ErrorMessageType,
};

export const AllSoldOrderList = createAsyncThunk(
  "SoldOrderList/AllSoldOrderList",
  (data: any) => GetSoldOrderList(data)
);

const SoldOrderListSlice = createSlice({
  name: "SoldOrderList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(
        AllSoldOrderList.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.statusCode === 200) {
            let data = action.payload.data;
            state.rowsPerPage = data.limit;
            state.currentPage = data.page;
            state.totalPage = data.totalPages;
            state.totalRows = data.totalRows;

            state.SoldProductData = data.rows.map(
              (item: any, index: number) => ({
                id: item.orderId,
                srNo: index + 1,
                name: item.name,
                customerName:
                  item.order.user.firstName + " " + item.order.user.lastName,
                phone: item.order.user.phone,
                createdAt: item.createdAt,
                quantity: item.quantity,
                sellingPrice: Math.round(
                  item.sellingPrice +
                  (Number(item.sellingPrice) *
                    Number(
                      item.sellingOrderItemTaxes?.length > 1
                        ? item.sellingOrderItemTaxes?.reduce(
                          (acc: any, cur: any) =>
                            Number(acc.percentage) + Number(cur.percentage)
                        )
                        : item.sellingOrderItemTaxes[0].percentage
                    )) /
                  100
                ),
                totalAmount: Math.round(
                  item.totalAmount +
                  (Number(item.totalAmount) *
                    Number(
                      item.sellingOrderItemTaxes?.length > 1
                        ? item.sellingOrderItemTaxes?.reduce(
                          (acc: any, cur: any) =>
                            Number(acc.percentage) + Number(cur.percentage)
                        )
                        : item.sellingOrderItemTaxes[0].percentage
                    )) /
                  100
                ),
                status: item.status,
                hash: item.hash,
              })
            );
          }
        }
      )
      .addCase(AllSoldOrderList.rejected, (state, action) => {
            state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default SoldOrderListSlice.reducer;
